import axios from 'axios';
import { toast } from 'react-toastify';

const API_URL = process.env.REACT_APP_API_URL;

export const sendEmailAndVerify = async (email: string, codeuser: string) => {
    try {
        const response = await axios.post(`${API_URL}/email/code`, {
            email,
            codeuser
        });

        return response.data;
    } catch (error) {
        console.error('Erreur lors de l\'envoi ou de la vérification du code:', error);
        toast.error('Erreur lors de l\'envoi ou de la vérification du code par e-mail');
        throw error;
    }
};
